/**
 * KSK2021_R01 품목(itemCd) 라벨 데이터 빌더
 * LOT 개념 없이 헤더의 생산양품량(productQty) 기준으로 "저장 1건 = 라벨 1장"을 만든다.
 * (MES PRD3011_R01 방식과 동일)
 */

import { ItemLabelPrintData } from "src/apis/itemLabelApi";
import { formatDate } from "src/utils/string/stringUtil";
import { KSK2021_R01DetailDto, KSK2021_R01HeaderDto } from "./Dto_KSK2021_R01";
import { Store_KSK2021_R01 } from "./Store_KSK2021_R01";

export interface KSK2021_R01StoreData {
	KSK2021_R01DetailList: KSK2021_R01DetailDto[];
	editKSK2021_R01: KSK2021_R01HeaderDto | null;
}

const formatQty = (qty: number | undefined, unit: string): string => {
	if (!qty && qty !== 0) return '';
	return `${qty.toLocaleString()}${unit || 'EA'}`;
};

/**
 * 헤더 → ItemLabelPrintData 1건 변환
 * 품명은 itemCd 라벨 템플릿이 폭에 맞춰 자동 축소하므로 절단하지 않는다.
 */
export const KSK2021_R01_buildItemLabelData = (
	header: KSK2021_R01HeaderDto
): ItemLabelPrintData => {
	if (!header) throw new Error('입고 정보를 찾을 수 없습니다');
	if ((header.productQty || 0) <= 0) throw new Error('생산수량이 없어 라벨을 생성할 수 없습니다');

	const transportDate = header.productDt
		? formatDate(new Date(header.productDt))
		: formatDate(new Date());
	const storageLocation = (header as any).locationCd?.trim() || '-';

	return {
		itemCd: header.itemCd || '',
		itemNm: header.itemNm || '',
		itemSpec: header.itemSpec || '',
		qty: formatQty(header.productQty, header.itemUnit || 'EA'),
		transportDate,
		storageLocation,
		customer: (header as any).customerNm ?? (header as any).customNm ?? '',
		customerItemCd: (header as any).customerItemCd ?? '',
		labelType: '[생산입고]',
	};
};

/**
 * 저장 시 헤더 생산양품량 기준 품목 라벨 데이터 추출 (자동 출력용)
 */
export const KSK2021_R01_extractUnprintedItemLabelData = (
	store: Pick<Store_KSK2021_R01, 'editKSK2021_R01'>
): ItemLabelPrintData[] => {
	const header = store.editKSK2021_R01;
	if (!header || (header.productQty || 0) <= 0) {
		return [];
	}

	try {
		return [KSK2021_R01_buildItemLabelData(header)];
	} catch (error) {
		console.error('품목 라벨 데이터 생성 실패:', error);
		return [];
	}
};
